import { useSetRecoilState } from 'recoil'
import { checkHistoryDisplay } from '../../services/history/historyServiceURL'
import useCallApi from '../../utilities/axios'

import { historyStore } from './useHistoryStore'

const useHistoryAction = () => {
    const setHistoryStore = useSetRecoilState(historyStore)
    const callApi = useCallApi()

    const updateDisplayHistory = async (submittedID: number) => {
        const response = await callApi.axiosGet({
            url: `${checkHistoryDisplay}/${submittedID}`,
        })
        const result = response?.data?.result
        if (response && response?.data?.status === 1 && result) {
            setHistoryStore((prevState) => ({
                displayVerifyDocHistory: result.historyVerifyDoc,
                displayConsiderTypeHistory: result.historyConsiderType,
            }))
        }
    }

    return {
        updateDisplayHistory,
    }
}

export default useHistoryAction
